import {
  GET_IDDAA_COUPON_INFO_REQUEST,
  GET_IDDAA_COUPON_INFO_SUCCESS,
  GET_IDDAA_COUPON_INFO_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_IDDAA_COUPON_INFO_REQUEST:
      return { ...state, data: {}, isLoading: true, error: null };
    case GET_IDDAA_COUPON_INFO_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: false };
    case GET_IDDAA_COUPON_INFO_FAILURE:
      return { ...state, data: {}, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
